import React, { ReactNode } from 'react'

import { Box, CircularProgress } from '@mui/material'
import { Navigate } from 'react-router-dom'

import useAccess from '../../hooks/useAccess'
import { UserRole } from '../../user'

type RoleGuardPropsType = {
  roles: UserRole[]
  isRoute?: boolean
  children: ReactNode
}

export const RoleGuard: React.FC<RoleGuardPropsType> = ({ roles, isRoute = true, children }) => {
  const hasAccess = useAccess(roles)

  if (hasAccess === null) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    )
  }

  if (hasAccess) return <>{children}</>

  return isRoute ? <Navigate to="/login" /> : null
}
